/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S11_Qnb_LabelInputs */

const tr_mesafeli_s11_qnb_label = /** @type {(inputs: Mesafeli_S11_Qnb_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QNB eSolutions (TR):`)
};

const en_mesafeli_s11_qnb_label = /** @type {(inputs: Mesafeli_S11_Qnb_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QNB eSolutions (TR):`)
};

const de_mesafeli_s11_qnb_label = /** @type {(inputs: Mesafeli_S11_Qnb_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QNB eSolutions (TR):`)
};

const ru_mesafeli_s11_qnb_label = /** @type {(inputs: Mesafeli_S11_Qnb_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QNB eSolutions (TR):`)
};

/**
* | output |
* | --- |
* | "QNB eSolutions (TR):" |
*
* @param {Mesafeli_S11_Qnb_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s11_qnb_label = /** @type {((inputs?: Mesafeli_S11_Qnb_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S11_Qnb_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s11_qnb_label(inputs)
	if (locale === "de") return de_mesafeli_s11_qnb_label(inputs)
	if (locale === "ru") return ru_mesafeli_s11_qnb_label(inputs)
	return tr_mesafeli_s11_qnb_label(inputs)
});